module.exports = __webpack_public_path__ + "img/volgograd.b2d810c9.jpg";